import { Link, NextImage } from "@jog/react-components";
export const Logo = ({ href = "/", ...imageProps }) => (<div className="flex items-center justify-center">
        <Link href={href}>
            <NextImage blur={false} {...imageProps} className="h-auto w-auto max-w-[150px] lg:max-w-[200px]"/>
        </Link>
    </div>);
